import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { sendContactMessage } from 'actions/contact.action'
import { RootState } from 'reducers/rootReducer'
import IContact, { IContactMutation } from 'models/Contact/IContact'
import { TranslationKeys } from 'types/TranslationKeys'

export interface FormProps {
  t: (key: TranslationKeys) => string
}

export const useForm = (props: FormProps) => {
  const dispatch = useAppDispatch()

  const isLoading = useSelector((state: RootState) => state.contact.isLoading)
  const isSendContactMessageSuccess = useSelector(
    (state: RootState) => state.contact.isSendContactMessageSuccess
  )
  const isSendContactMessageFailed = useSelector(
    (state: RootState) => state.contact.isSendContactMessageFailed
  )

  const [contactFormData, setContactFormData] = useState<IContact>({
    name: '',
    email: '',
    subject: '',
    message: '',
  })

  const handleControllerChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target
    setContactFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      if (
        contactFormData.name !== '' ||
        contactFormData.email !== '' ||
        contactFormData.subject !== '' ||
        contactFormData.message !== ''
      ) {
        const contactMutation: IContactMutation = {
          mutations: [
            {
              create: {
                _type: 'form',
                ...contactFormData,
              },
            },
          ],
        }

        await dispatch(sendContactMessage(contactMutation))
      }
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }

  useEffect(() => {
    if (isSendContactMessageSuccess)
      setContactFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
      })
  }, [isSendContactMessageSuccess])

  return {
    ...props,
    contactFormData,
    isLoading,
    isSendContactMessageSuccess,
    isSendContactMessageFailed,
    handleControllerChange,
    handleFormSubmit,
  }
}
